import axios from "../utils/axios";

export const getSimpleStepSection = async () => {
    const response = await axios.get("/simple-step-sections/first");
    return response.data;
};

export const updateSimpleStepSection = async (data) => {
    const response = await axios.put("/simple-step-sections/first", data);
    return response.data;
};
